import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, ComputedRef, onMounted, ref, Ref, watch } from 'vue';
import { DeliverableForPickUp, LabelWithNamedArguments, B2CClientService } from '@/b2c/shared/api/server-apis';
import useBasket from '../../useBasket';
import utilitiesService from '@/shared/utilities.service';
import { forEach } from 'lodash';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import { useDeliverables } from '@/b2c/basket/useDeliverables';

export default /*#__PURE__*/_defineComponent({
  __name: 'PickUp',
  props: {
    deliverable: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: DeliverableForPickUp;
};

const { basketId } = useBasket();
const { quantities } = useDeliverables();
const label: Ref<LabelWithNamedArguments | undefined> = ref(undefined);



onMounted(() => {
    if (props.deliverable.hubId) {
        getEarliestHubPickUpDate();
    }
});

const blockLabelAnimationKey: ComputedRef<string> = computed(() => {
    let key = '';
    if (label.value) {
        forEach(label.value.namedParams, p => key += p);
    }

    return key;
});

const deliverableQuantities: ComputedRef<number> = computed(() => {
    return quantities(props.deliverable.items);
});

watch(deliverableQuantities, newQuantities => {
    if (props.deliverable.hubId) {
        getEarliestHubPickUpDate();
    }
});

const getEarliestHubPickUpDate = async(): Promise<void> => {
    if (!props.deliverable.hubId) return;
    const response = await B2CClientService
        .getEarliestHubPickUpDateForBasket(basketId.value, props.deliverable.hubId)
        .then(utilitiesService.unwrapModel);
    label.value = response?.text;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (label.value)
          ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
              key: _unref(blockLabelAnimationKey),
              label: label.value
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})